import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface DialogPortalProps {
  children: ReactNode
}

/**
 * Renders dialog content at document.body via createPortal.
 * Wraps children in a .funnels-theme div so CSS custom properties
 * (--fn-*) cascade correctly to the portaled elements.
 *
 * This fixes `position: fixed` being constrained when an ancestor
 * creates a CSS containing block (e.g. via animation, transform, or will-change).
 */
export function DialogPortal({ children }: DialogPortalProps) {
  return createPortal(
    <div className="funnels-theme">{children}</div>,
    document.body,
  )
}
